import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { externalLogin } from 'redux/auth/actions';
import { Backdrop } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

export default function ExternalAuth() {
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();
  const pathSegments = location.pathname.split('/').filter(Boolean);
  const routeParams = Object.keys(params).length
    ? params
    : {
        tokenHeader: pathSegments[1],
        tokenPayload: pathSegments[2],
        tokenSignature: pathSegments[3],
        refreshTokenHeader: pathSegments[4],
        refreshTokenPayload: pathSegments[5],
        refreshTokenSignature: pathSegments[6]
      };
  const { tokenHeader, tokenPayload, tokenSignature, refreshTokenHeader, refreshTokenPayload, refreshTokenSignature } =
    routeParams;

  const accessToken =
    tokenHeader && tokenPayload && tokenSignature ? `${tokenHeader}.${tokenPayload}.${tokenSignature}` : '';

  const refreshToken =
    refreshTokenHeader && refreshTokenPayload && refreshTokenSignature
      ? `${refreshTokenHeader}.${refreshTokenPayload}.${refreshTokenSignature}`
      : '';

  const authorization = {
    access: accessToken,
    refresh: refreshToken
  };

  useEffect(() => {
    if (!authorization.access || !authorization.refresh) {
      window.location = '/login';
      return;
    }

    dispatch(externalLogin(authorization));
  }, [authorization.access, authorization.refresh, dispatch]);

  return (
    <Backdrop sx={{ color: '#8CB4C7', zIndex: theme => theme.zIndex.drawer + 1 }} open>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
